export const getLogo = (product) => product?.images?.pc?.[0]?.miniUrl;
